// import {Image,Header,Main,Footer,Button,Input, Table,TableColumn,Pagination,Form,FormItem,Tree, Dialog,Message} from 'element-ui'
import {Image} from 'element-ui'
const element = {
  install: function (Vue) {
    Vue.use(Image)
    // Vue.use(Header)
    // Vue.use(Main)
    // Vue.use(Footer)
    // Vue.use(Button)npm i element-ui -S
    // Vue.use(Table)
    // Vue.use(TableColumn)
    // Vue.use(Pagination)
    // Vue.use(Form)
    // Vue.use(FormItem)
    // Vue.use(Input)
    // Vue.use(Tree)
    // Vue.use(Dialog)
    // Vue.prototype.$message = Message
    // // 解决首次进入自动弹出的问题
    // Vue.component(Message.name, Message)
  }
}
export default element



// WEBPACK FOOTER //
// ./src/element/index.js